// extracted by mini-css-extract-plugin
module.exports = {"goalsDataStyle":"_2mR-Pgpzzk_oYta-Y2qFfk","archivedGoalsStyle":"_37A1fVh44l50dwXhJD4s2u"};